import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../../../commn/Navbar";
import { Contact } from "../../home/Contact";

export const NewsC = () => {
  const [item, setItem] = useState([]);
  const [viewCount, setViewCount] = useState(0);
  const [hasIncremented, setHasIncremented] = useState(false);
  const page = "news";

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get("/api/newsevent/get");
        const sortedItems = res.data.sort((a, b) => {
          if (a._id > b._id) return -1;
          if (a._id < b._id) return 1;
          return 0;
        });
        setItem(sortedItems);
      } catch (err) {
        console.log(err);
      }
    };

    const fetchPageViews = async () => {
      try {
        const response = await fetch(`/api/pageView/${page}`);
        const data = await response.json();
        setViewCount(data.count);
      } catch (error) {
        console.error("Error fetching page view count:", error);
      }
    };

    const incrementPageView = async () => {
      try {
        await fetch(`/api/pageView/${page}/increment`, {
          method: "POST",
        });
        setHasIncremented(true);
      } catch (error) {
        console.error("Error incrementing page view count:", error);
      }
    };

    if (!hasIncremented) {
      fetchPageViews();
      incrementPageView();
    } else {
      fetchPageViews();
    }

    fetchNews();
  }, [page, hasIncremented]);

  return (
    <div className="bggray">
      <Navbar />
      <div className="mt-5 my-5">
        <div className="">
          <br></br>
          <div className="text-center my-5">
            <h1 className="text-white" style={{ textShadow: "0 2px 4px rgba(0,0,0,0.5)" }}>News And Events</h1>
          </div>
          {item.map((news) => {
            const firstImage =
              news.images && news.images.length > 0 ? news.images[0] : ""; // Get the first image
            return (
              <section
                className="py-2 mx-3 mt-3 bgwhite shadow rounded-4 border-0"
                id="scroll-target"
                key={news._id} // Add a unique key prop
              >
                <div className="container px-5 my-3">
                  <div className="row justify-content-center text-center py-4">
                    <div className="col-lg-8">
                      <div className="">
                        {firstImage && (
                          <img
                            style={{ width: "50%", height: "50%" }}
                            className="mb-5 rounded shadow hover-zoom"
                            src={`/newsevent/${firstImage}`}
                            alt={news.name}
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        )}
                      </div>
                      <h3 className="fw-bolder mb-2 text-white">{news.name}</h3>
                      <Link to={`/news/${news._id}`}>
                        <button className="premium-button premium-btn-primary mt-3">
                          Read More
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </section>
            );
          })}
        </div>
      </div>
      <Contact />
    </div>
  );
};
